import { render, staticRenderFns } from "./recordOrder.vue?vue&type=template&id=a17b663a&scoped=true"
import script from "./recordOrder.vue?vue&type=script&lang=js"
export * from "./recordOrder.vue?vue&type=script&lang=js"
import style0 from "./recordOrder.vue?vue&type=style&index=0&id=a17b663a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17b663a",
  null
  
)

export default component.exports